import React, { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import type { RouteComponentProps } from 'react-router';

import { getSinkDatasetMemoized } from '../../../internals/pipes';
import { DatasetActions } from '../../../redux-store/thunks/datasets.thunks';
import { leafPipesSelector } from '../../../redux-store/selectors';

import { DatasetInspectorContainer } from '../../../components/dataset-inspector/DatasetInspectorContainer';

import Box from '../../../components/common/Box/Box';
import PipeStatus from '../../../components/pipe-status/PipeStatus';

import type { RootState } from '../../../types/state.types';
import type { Pipe } from '../../../types/pipes.types';

export const PipeExecutionLog: React.FC<
  RouteComponentProps<{}, any> & {
    inputPipe?: Pipe;
    addCustomActions: () => void;
    registerRefresh: (func: Function) => void;
    unregisterRefresh: (func: Function) => void;
    removeCustomActions: () => void;
  }
> = ({
  inputPipe,
  registerRefresh,
  unregisterRefresh,
  addCustomActions,
  removeCustomActions,
  params,
}) => {
  const { subId, pipeID } = params;

  const dispatch = useDispatch();

  const pipe = useSelector((state: RootState) => inputPipe ?? state.pipes[pipeID]);
  const leafPipes = useSelector((state: RootState) => leafPipesSelector(state));
  const isPipeLeaf = leafPipes.includes(pipeID);
  const datasets = useSelector((state: RootState) => state.datasets);

  const loadDataset = (id: string) => dispatch(DatasetActions.load(id));

  const refreshSinkDataset = () => {
    const sinkDataset = getSinkDatasetMemoized(pipe, datasets);
    if (sinkDataset) {
      loadDataset(sinkDataset._id);
    }
  };

  useEffect(() => {
    registerRefresh(refreshSinkDataset);
    refreshSinkDataset();

    return unregisterRefresh(refreshSinkDataset);
  }, []);

  const sinkDataset = getSinkDatasetMemoized(pipe, datasets);

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'stretch',
        flexDirection: 'column',
        flex: '1 1 auto',
        height: '100%',
      }}
    >
      <div style={{ alignSelf: 'flex-start', marginBottom: '10px', width: '100%' }}>
        {/* @ts-ignore */}
        <Box>
          {/* @ts-ignore */}
          <Box.Content compact>
            {pipe && (
              <PipeStatus
                pipe={pipe}
                sinkDataset={sinkDataset}
                subId={subId}
                isPipeLeaf={isPipeLeaf}
              />
            )}
          </Box.Content>
        </Box>
      </div>
      <DatasetInspectorContainer
        addCustomActions={addCustomActions}
        datasetId={`system:pump:${pipeID}`}
        registerRefresh={registerRefresh}
        removeCustomActions={removeCustomActions}
        unregisterRefresh={unregisterRefresh}
        isPipeExecutionLog={true}
        tab="execution"
      />
    </div>
  );
};
